import { render } from "./materielForm.vue?vue&type=template&id=516076e6"
import script from "./materielForm.vue?vue&type=script&lang=js"
export * from "./materielForm.vue?vue&type=script&lang=js"

import "./materielForm.vue?vue&type=style&index=0&id=516076e6&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Web apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__